import React, { useState, useEffect } from "react";
import styles from "../Footer/Footer2.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import ModalHelp from "../../ModalHelp/ModalHelp";
import HelpSupport from "../../HelpSupport/HelpSupport";
import { listAgents } from '../../../Store/apiStore';
import useTeamPermissions from "../../../hooks/useTeamPermissions";
import { useTeamStore } from "../../../Store/teamStore";
import LockOverlay from "../../LockOverlay/LockOverlay";
import decodeToken from "../../../lib/decodeToken";
import NewModal from "../../NewModal/NewModal";
import { isPythonBackend } from "../../../utils/apiBackend";
// import Plan from '../../Plan/Plan'
// import ChatBox from '../../ChatBox/ChatBox';
// import Modal from "../../Modal/Modal";

const Footer2 = ({ userId }) => {
  const [activeTab, setActiveTab] = useState("home");
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [agentCount, setAgentCount] = useState()
  const [ownAgentCount, setOwnAgentCount] = useState(0)
  const [agentLoading, setAgentLoading] = useState(true); // ADD THIS

  // The logged-in account's OWN id (not whichever owner's agent is on screen).
  // Used to count the admin's own agents so Create can be locked after one.
  const selfId = decodeToken(localStorage.getItem("token") || "")?.id || null;

  const navigate = useNavigate();
  const location = useLocation();
  const { isTeamMember, canViewAppointments } = useTeamPermissions(60000);

  // Admin team members may create THEIR OWN agent and open Contacts (the
  // contacts screen has its own company selector). Both are account-level
  // actions, so they hinge on "is this person an admin of ANY company" — not on
  // whichever owner happens to resolve first. Support stays locked out.
  const teams = useTeamStore((s) => s.teams);
  const loadTeams = useTeamStore((s) => s.loadTeams);
  useEffect(() => {
    if (isTeamMember) loadTeams();
  }, [isTeamMember, loadTeams]);
  const adminsAnyCompany = (teams || []).some((t) => t.role === "admin");
  const teamLocked = isTeamMember && !adminsAnyCompany;

  // Create button lock:
  //   - Support: always locked (teamLocked).
  //   - Admin: allowed exactly ONE own agent — once they've built it, Create
  //     locks too (they manage owners' agents but can't spin up more of their
  //     own).
  //   - Plain owners: unchanged (may create freely).
  const adminMaxedOut = adminsAnyCompany && (Number(ownAgentCount) || 0) >= 1;
  const createLocked = teamLocked || adminMaxedOut;

  // Home destination. Admins ALWAYS return to the grouped dashboard (matches the
  // login-landing rule: an admin lands on the dashboard with 1 or 2+ agents).
  // Everyone else goes to the multi-agent dashboard only when they have 2+
  // agents, otherwise the single-agent home.
  const homeToDashboard = adminsAnyCompany || (Number(agentCount) || 0) > 1;
  const homePath = homeToDashboard ? "/dashboard" : "/fast-agent-detail";

  useEffect(() => {
    if (location.pathname.includes("/fast-agent-detail")) {
      setActiveTab("home");
    } else if (location.pathname.includes("/calendar")) {
      setActiveTab("calendar");
    } 
    else if (location.pathname.includes("/contacts")) {
      setActiveTab("contacts");
    }
    // else if (location.pathname.includes("/totalcall-list")) {
    //   setActiveTab("info");
    // }
  }, [location.pathname]);
  const fetchAgentCountFromUser = async () => {
    try {
      setAgentLoading(true);
      const response = await listAgents()
      const filterAgents = await response.filter(res => res.userId === userId)
      // console.log({filterAgents})
      setAgentCount(filterAgents.length)
      // Admin's OWN agents (under their own login id) — used to lock Create
      // once they've built their single allowed agent.
      if (selfId) {
        setOwnAgentCount(response.filter((res) => res.userId === selfId).length)
      }
      // console.log(userId, "userid", filterAgents.length)
    } catch (error) {
      setAgentCount(0); // error pe 0 set karo
      setOwnAgentCount(0);

      console.log(error)
    } finally {
      setAgentLoading(false); 
    }
  }
  const handleTabClick = (tab, path) => {
    setActiveTab(tab);
    navigate(path);
  };
  useEffect(() => {
    fetchAgentCountFromUser()
  }, [userId])
  const handleNavigate = () => {
    if (agentLoading) return;
    // Locked for support, and for admins who already built their one own agent.
    if (createLocked) return;
    // Create → the NEW onboarding flow (Fast Setup). Same entry the rest of the
    // app uses (Dashboard / FastAgentDetails / FooterNew): /business-step with
    // mode "new". Previously this dropped existing users onto /plan and new
    // users onto the old /fork path.
    navigate("/business-step", { state: { mode: "new" } });
  }

  // Create → pehle poocho kaunsa agent. Pounce Retell outbound pe chalta hai,
  // Python (India) agent ke paas wo nahi — wahan seedha receptionist flow.
  const [showCreateChoice, setShowCreateChoice] = useState(false);
  const handleCreateClick = () => {
    if (agentLoading || createLocked) return;
    if (isPythonBackend()) {
      handleNavigate();
      return;
    }
    setShowCreateChoice(true);
  };
  const createReceptionist = () => {
    setShowCreateChoice(false);
    handleNavigate();
  };
  // Wahi Pounce onboarding jo More → "Faster Conversions" se khulta hai:
  // business steps → plan + card → Pounce agent → /dashboard.
  const createPounce = () => {
    setShowCreateChoice(false);
    navigate("/business-step", { state: { mode: "new", flow: "pounce" } });
  };
  return (
    <>
      <div>
        <div className={styles.navbar}>
          {/* Home */}
          <button
            className={`${styles.tab} ${activeTab === "home" ? styles.active : ""}`}
            onClick={() => handleTabClick("home", homePath)}
            aria-current={activeTab === "home" ? "page" : undefined}
          >
            <span className={styles.icon}>
              <svg
                width="28"
                height="31"
                viewBox="0 0 28 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M27.0129 12.0915L26.0129 22.735C26.0129 26.7616 22.7184 30.0551 18.6928 30.0551H8.32012C4.29455 30.0551 1 26.7616 1 22.735L0 12.0915C0 10.1557 0.819416 8.49008 2.35197 7.30913L9.82008 1.55335C12.0221 -0.144085 14.9899 -0.144085 17.1918 1.55335L24.66 7.30913C26.1925 8.49008 27.0129 10.1557 27.0129 12.0915ZM8.99055 23.6339C8.57935 23.6339 8.24662 23.3012 8.24662 22.89C8.24662 22.4788 8.57935 22.146 8.99055 22.146H18.0224C18.4336 22.146 18.7663 22.4788 18.7663 22.89C18.7663 23.3012 18.4336 23.6339 18.0224 23.6339H8.99055Z"
                  fill="#5F33E1"
                />
              </svg>
            </span>
          </button>

          {/* Calendar */}
          <LockOverlay locked={!canViewAppointments}>
          <button
            id="tour-footer-calendar"
            className={`${styles.tab} ${activeTab === "calendar" ? styles.active : ""}`}
            onClick={() => handleTabClick("calendar", "/calendar")}
            aria-current={activeTab === "calendar" ? "page" : undefined}
          >
            <span className={styles.icon}>
              {/* <svg
                width="26"
                height="31"
                viewBox="0 0 26 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  d="M25.9997 8.82162V6.1039C26.001 5.20803 25.6546 4.34916 25.0361 3.71493C24.4164 3.08207 23.5771 2.72729 22.7017 2.72866H20.7421V1.09586C20.7421 0.490382 20.2629 0 19.6713 0C19.0796 0 18.6005 0.490382 18.6005 1.09586V2.72866H14.0708V1.09586C14.0708 0.490382 13.5916 0 12.9999 0C12.4083 0 11.9291 0.490382 11.9291 1.09586V2.72866H7.39944V1.09586C7.39944 0.490382 6.92025 0 6.32861 0C5.73696 0 5.25778 0.490382 5.25778 1.09586V2.72866H3.29815C2.42275 2.7273 1.58349 3.08207 0.963748 3.71493C0.345341 4.34916 -0.00133459 5.20803 3.86125e-06 6.1039V8.82162H25.9997Z"
                  fill="#5F33E1"
                />
                <path
                  d="M3.86125e-06 11.0156V26.9604C-0.00133459 27.8563 0.345341 28.7152 0.963748 29.3494C1.58349 29.9822 2.42275 30.337 3.29815 30.3357H22.7015C23.5769 30.337 24.4162 29.9822 25.0359 29.3494C25.6543 28.7152 26.001 27.8563 25.9997 26.9604V11.0156H3.86125e-06ZM7.30561 27.3069H5.35404C4.76777 27.2987 4.29794 26.8096 4.29794 26.211C4.29794 25.6124 4.76777 25.1234 5.35404 25.1152H7.30695H7.30561C7.89054 25.1248 8.36037 25.6124 8.36037 26.211C8.36037 26.8096 7.89054 27.2973 7.30561 27.3069ZM7.30561 21.7715H5.35404C4.76777 21.7633 4.29794 21.2742 4.29794 20.6756C4.29794 20.077 4.76777 19.588 5.35404 19.5798H7.30695H7.30561C7.89054 19.588 8.3617 20.077 8.3617 20.6756C8.3617 21.2742 7.89188 21.7633 7.30561 21.7715ZM7.30561 16.2361H5.35404C4.76777 16.2279 4.29794 15.7389 4.29794 15.1403C4.29794 14.5417 4.76777 14.0526 5.35404 14.0444H7.30695H7.30561C7.89054 14.054 8.36037 14.5417 8.36037 15.1403C8.36037 15.7389 7.89054 16.2265 7.30561 16.2361ZM13.9434 27.3069H11.9905C11.4055 27.2987 10.9344 26.8096 10.9344 26.211C10.9344 25.6124 11.4055 25.1234 11.9905 25.1152H13.9434C14.5283 25.1248 14.9968 25.6124 14.9968 26.211C14.9968 26.8096 14.5283 27.2973 13.9434 27.3069ZM13.9434 21.7715H11.9905C11.4055 21.7633 10.9344 21.2742 10.9344 20.6756C10.9344 20.077 11.4055 19.588 11.9905 19.5798H13.9434C14.5283 19.588 14.9981 20.077 14.9981 20.6756C14.9981 21.2742 14.5283 21.7633 13.9434 21.7715ZM13.9434 16.2361H11.9905C11.4055 16.2279 10.9344 15.7389 10.9344 15.1403C10.9344 14.5417 11.4055 14.0526 11.9905 14.0444H13.9434C14.5283 14.054 14.9968 14.5417 14.9968 15.1403C14.9968 15.7389 14.5283 16.2265 13.9434 16.2361ZM20.6466 27.3069H18.6937C18.1074 27.2987 17.6376 26.8096 17.6376 26.211C17.6376 25.6124 18.1087 25.1234 18.6937 25.1152H20.6466H20.6452C21.2302 25.1248 21.7 25.6124 21.7 26.211C21.7 26.8096 21.2302 27.2973 20.6452 27.3069H20.6466ZM20.6466 21.7715H18.6937C18.1074 21.7633 17.6376 21.2742 17.6376 20.6756C17.6376 20.077 18.1087 19.588 18.6937 19.5798H20.6466H20.6452C21.2315 19.588 21.7013 20.077 21.7013 20.6756C21.7013 21.2742 21.2315 21.7633 20.6452 21.7715H20.6466ZM20.6466 16.2361H18.6937C18.1074 16.2279 17.6376 15.7389 17.6376 15.1403C17.6376 14.5417 18.1087 14.0526 18.6937 14.0444H20.6466H20.6452C21.2302 14.054 21.7 14.5417 21.7 15.1403C21.7 15.7389 21.2302 16.2265 20.6452 16.2361H20.6466Z"
                  fill="#B5A0F3"
                />
              </svg> */}
              <svg width="26" height="31" viewBox="0 0 26 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path
                  d="M25.9997 8.82162V6.1039C26.001 5.20803 25.6546 4.34916 25.0361 3.71493C24.4164 3.08207 23.5771 2.72729 22.7017 2.72866H20.7421V1.09586C20.7421 0.490382 20.2629 0 19.6713 0C19.0796 0 18.6005 0.490382 18.6005 1.09586V2.72866H14.0708V1.09586C14.0708 0.490382 13.5916 0 12.9999 0C12.4083 0 11.9291 0.490382 11.9291 1.09586V2.72866H7.39944V1.09586C7.39944 0.490382 6.92025 0 6.32861 0C5.73696 0 5.25778 0.490382 5.25778 1.09586V2.72866H3.29815C2.42275 2.7273 1.58349 3.08207 0.963748 3.71493C0.345341 4.34916 -0.00133459 5.20803 3.86125e-06 6.1039V8.82162H25.9997Z"
                  fill="#5F33E1"
                />
                <path
                  d="M3.86125e-06 11.0156V26.9604C-0.00133459 27.8563 0.345341 28.7152 0.963748 29.3494C1.58349 29.9822 2.42275 30.337 3.29815 30.3357H22.7015C23.5769 30.337 24.4162 29.9822 25.0359 29.3494C25.6543 28.7152 26.001 27.8563 25.9997 26.9604V11.0156H3.86125e-06Z"
                  fill="#B5A0F3"
                />
              </svg>
            </span>
          </button>
          </LockOverlay>

          {/* Create — admins can build ONE own agent, then it locks; support
              can't create at all. */}
          <LockOverlay locked={createLocked} iconTop="0%">
            <div
              className={styles.createWrapper}
              onClick={() => setOpen(true)}
            >
              <button
                id="tour-footer-create"
                className={styles.createBtn}
                onClick={handleCreateClick}
                aria-label="Create"
              >
                <span className={styles.createIcon}>+</span>
                <span className={styles.createText}>Create</span>
              </button>
            </div>
          </LockOverlay>

          {/* Support / Info */}
          {/* <button
          {/* Support / Info - Call Logs */}
          {/* Contacts — owners + admins (of any company); support locked. */}
          <LockOverlay locked={teamLocked}>
          {/* <button
            id="tour-footer-support"
            className={`${styles.tab} ${activeTab === "info" ? styles.active : ""}`}
            aria-current={activeTab === "info" ? "page" : undefined}
            onClick={() => handleTabClick("info", "/totalcall-list")}
          >
            <span className={styles.icon}>
              <img src="svg/Call-handled-icon.svg" alt="Call-handled-icon" />
            </span>
          </button>  */}
            <button
            id="tour-footer-contacts"
            className={`${styles.tab} ${activeTab === "contacts" ? styles.active : ""}`}
            onClick={() => handleTabClick("contacts", "/contacts")}
            aria-current={activeTab === "contacts" ? "page" : undefined}
          >
            <span className={styles.icon}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                  stroke="#5F33E1" strokeWidth="2" strokeLinecap="round" fill="none"/>
                <circle cx="9" cy="7" r="4"
                  stroke="#B5A0F3" strokeWidth="2" fill="none"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                  stroke="#5F33E1" strokeWidth="2" strokeLinecap="round" fill="none"/>
              </svg>
            </span>
          </button>
          </LockOverlay>
        </div>

        {/* Create → kaunsa agent? */}
        <NewModal
          isOpen={showCreateChoice}
          onClose={() => setShowCreateChoice(false)}
          title="Create an agent"
          height="auto"
        >
          <div className={styles.createChoiceList}>
            <button
              type="button"
              className={styles.createChoice}
              onClick={createReceptionist}
            >
              <span className={styles.createChoiceIcon} aria-hidden="true">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
                  <path
                    d="M5 4h3l2 5-2.5 1.5a11 11 0 0 0 6 6L15 14l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z"
                    stroke="#5F33E1"
                    strokeWidth="1.8"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span className={styles.createChoiceText}>
                <span className={styles.createChoiceTitle}>Receptionist agent</span>
                <span className={styles.createChoiceDesc}>Answers your incoming calls 24/7</span>
              </span>
              <img src="/svg/setup_arrow_icon.svg" alt="" aria-hidden="true" />
            </button>
            <button
              type="button"
              className={styles.createChoice}
              onClick={createPounce}
            >
              <span className={styles.createChoiceIcon} aria-hidden="true">
                <img src="/svg/outbound_caller_icon.svg" alt="" />
              </span>
              <span className={styles.createChoiceText}>
                <span className={styles.createChoiceTitle}>Outbound Caller agent</span>
                <span className={styles.createChoiceDesc}>Calls your new leads within 10 seconds</span>
              </span>
              <img src="/svg/setup_arrow_icon.svg" alt="" aria-hidden="true" />
            </button>
          </div>
        </NewModal>

        {/* Help Modal */}
        <ModalHelp isOpen={open2} onClose={() => setOpen2(false)}>
          <div>
            <HelpSupport />
          </div>
        </ModalHelp>

        {/* Plan Modal (currently unused)
      <Modal isOpen={open} onClose={() => setOpen(false)}>
        <Plan />
      </Modal> */}
      
      </div>

    </>
  );
};

export default Footer2;
//
